module.exports = require("@material-ui/icons/CloudUpload");